declare namespace $ {

	type $mol_list__sub_shm_hitalama_contextmenu_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_contextmenu['body'] >
		,
		ReturnType< $mol_list['sub'] >
	>
	type $shm_hitalama_hovered__hovered_shm_hitalama_contextmenu_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_contextmenu['hovered'] >
		,
		ReturnType< $shm_hitalama_hovered['hovered'] >
	>
	type $shm_listener__shm_hitalama_contextmenu_3 = $mol_type_enforce<
		[ string, ReturnType< $shm_hitalama_contextmenu['pointerdown_handler'] >, ReturnType< $shm_hitalama_contextmenu['document'] >, boolean ]
		,
		ConstructorParameters< typeof $shm_listener >
	>
	export class $shm_hitalama_contextmenu extends $mol_view {
		body( ): readonly(any)[]
		Body( ): $mol_list
		hovered( next?: boolean ): boolean
		Hovered( ): $shm_hitalama_hovered
		left( next?: string ): string
		top( next?: string ): string
		pointerenter( next?: any ): any
		pointerleave( next?: any ): any
		pointerdown_handler( ): any
		document( ): any
		pointerdown_listener( ): $shm_listener
		sub( ): readonly(any)[]
		plugins( ): readonly(any)[]
		pos( next?: readonly(any)[] ): readonly(any)[]
		show( next?: any ): any
		style( ): ({ 
			'left': ReturnType< $shm_hitalama_contextmenu['left'] >,
			'top': ReturnType< $shm_hitalama_contextmenu['top'] >,
		}) 
		event( ): ({ 
			pointerenter( next?: ReturnType< $shm_hitalama_contextmenu['pointerenter'] > ): ReturnType< $shm_hitalama_contextmenu['pointerenter'] >,
			pointerleave( next?: ReturnType< $shm_hitalama_contextmenu['pointerleave'] > ): ReturnType< $shm_hitalama_contextmenu['pointerleave'] >,
		}) 
		showed( next?: boolean ): boolean
		auto( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=contextmenu.view.tree.d.ts.map